angular
  .module("myApp")
  .controller(
    "PpRiskuIzvertejumsController",
    function (uuiData, $scope, Dialog, RiskuIzvertejumsSave, RiskuIzvertejumsDelete) {
      this.izvertejumi = []

      this.reload = () => {
        uuiData
          .record("pp_risku_izvertejumi", $scope.dto.id)
          .$promise.catch($scope.failing)
          .then((l) => {
            this.izvertejumi = l.izvertejumi
          })
      }

      this.newIzvertejums = () => {
        this.editIzvertejums({
          id: undefined,
          veica_datums: new Date(),
          veica_lietotajs_id: $scope.u.id,
          ieraksti: [
            { faktors: "Pētniecības pieteikuma/-u īstenotāja statuss", nozimigums: 3 },
            {
              faktors: "Pētniecības pieteikuma/-u īstenotāja Pētniecības pieteikuma/-u veids/-i",
              nozimigums: 3,
            },
            { faktors: "Pētniecības pieteikuma/-u īstenotāja partneru skaits", nozimigums: 2 },
            {
              faktors:
                "Pētniecības pieteikuma/-u īstenotāja iesniegtā/-o Pētniecības pieteikuma/-u neatkarīgo starptautisko ekspertu vērtējuma/-u vidējā vērtība",
              nozimigums: 5,
            },
            {
              faktors:
                "Pētniecības pieteikuma/-u īstenotāja pieredze Eiropas Savienības fonda/-u projektu īstenošanā",
              nozimigums: 4,
            },
          ],
        })
      }

      this.removeIeraksts = (dto, i) => {
        dto.ieraksti = _.reject(dto.ieraksti, (ii) => ii.faktors === i.faktors)
      }

      this.editIzvertejums = (i) => {
        i.removeIeraksts = this.removeIeraksts
        i.updateTotal = this.updateTotal

        if (i.veica_datums) i.veica_datums = moment(i.veica_datums, "YYYY-MM-DD").toDate()
        if (i.apstiprinaja_datums)
          i.apstiprinaja_datums = moment(i.apstiprinaja_datums, "YYYY-MM-DD").toDate()
        if (i.veica_lietotajs_id) {
          uuiData.record("lzp_eksperts_choice", i.veica_lietotajs_id).$promise.then((r) => {
            i.veica_lietotajs_name = r.name
          })
        }
        if (i.apstiprinaja_lietotajs_id) {
          uuiData.record("lzp_eksperts_choice", i.apstiprinaja_lietotajs_id).$promise.then((r) => {
            i.apstiprinaja_lietotajs_name = r.name
          })
        }

        Dialog.dialog("pages/dialogs/pp.risku-izvertejums.form.html", i, { wide: true }, (p, action) => {
          if (action === "delete") {
            const pp = new RiskuIzvertejumsDelete({
              id: $scope.dto.id,
              pieteikums_id: $scope.dto.pieteikums_id,
            })
            return Dialog.finish(pp, this.reload)
          } else if (action === "save") {
            p.pieteikums_id = $scope.dto.pieteikums_id

            this.updateTotal(p)

            const pp = new RiskuIzvertejumsSave(p)
            return Dialog.finish(pp, this.reload)
          }
        })
      }

      this.updateTotal = (izv) => {
        izv.kopsumma = 0
        izv.ieraksti.forEach((i) => {
          if (i.nozimigums && i.koeficients) {
            i.koeficients = +i.koeficients
            i.nozimigums = +i.nozimigums
            i.kopsumma = i.nozimigums * i.koeficients
            izv.kopsumma += i.kopsumma
          } else i.kopsumma = 0
        })
      }

      $scope.$on("enter.risku-izvertejums", this.reload)

      return this
    }
  )
